import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GETOPPOSITEENVREGION_REQ, GETCOMPANIES_REQ, GETMIGRATIONDETAILS_REQ, APIKEYVALIDATION_REQ ,GETMIGRATIONDEFAULTOBJECT_REQ } from "../../../../actions";
import { SearchDropdown, TextBox, } from "../../../../components/inputs";
import { toast } from "react-toastify";
import  DataMigrationConfig  from "../util/dataMigrationConfig"
const _ = require("underscore");

export default function ConfigMigration({ setStep, formik, isReadOnlyView, currentMigID }) {

    const oppositeENVRegionList = useSelector((state) => state?.migration?.migration_regions);
    const migrationDetails = useSelector((state) => state?.migration?.details);
    const customersList = useSelector((state) => state?.company?.list);
    const apikeyValidationResult = useSelector((state) => state?.migration?.migration_api_validation_result);
    const currentENVRegionList = JSON.parse(localStorage.getItem("regions")); // region from localstorage
    const dispatch = useDispatch();
    const urlParams = useRef({});
    const [regionData, setRegionData] = useState([]);
    const [enableDataMigration, setEnableDataMigration] = useState(false)
    const cloneSourceAccounts = useSelector((state) => state?.migration?.migration_default_object?.sourceCompanyDetails);
    const [cloneAccountIndustry,setCloneAccountIndustry] = useState(["None"])
    const [isFromSourceAccount, setisFromSourceAccount] = useState(false);

    const [companyList, setCompanyList] = useState({})
    const [dropDownOptions, setdropDownOptions] = useState([])

    var currentEnv = 'live'
    if (process.env.REACT_APP_ENV == 'development' || process.env.REACT_APP_ENV == 'staging') {
        currentEnv = 'staging'
    }
    useEffect(() => {
        dispatch(GETOPPOSITEENVREGION_REQ());
        dispatch(GETMIGRATIONDEFAULTOBJECT_REQ());
    }, []);
    
    useEffect(() => {
        if(cloneSourceAccounts?.length > 0){
            setCloneAccountIndustry(["None",...cloneSourceAccounts.map((obj) => obj.industry)])
        }
    }, [cloneSourceAccounts]);

    useEffect(() => {
        if (apikeyValidationResult.data && apikeyValidationResult.data.errorResult?.length == 0) {
            setStep("selectTemplate")
        }
        else if (apikeyValidationResult.data && apikeyValidationResult.data.errorResult) {
            for (let t = 0; t < apikeyValidationResult.data.errorResult?.length; t++) {
                toast(apikeyValidationResult.data?.errorResult[t].company, {
                    type: "error",
                });
            }
        }
    }, [apikeyValidationResult])

    useEffect(() => {
        if (migrationDetails?.data?.length) {
            formik.setFieldValue('from_company_login_name', migrationDetails.data[0].from_company_login_name)
            formik.setFieldValue('to_company_login_name', migrationDetails.data[0].to_company_login_name)
            formik.setFieldValue('from_company_region', migrationDetails.data[0].from_company_region)
            formik.setFieldValue('to_company_region', migrationDetails.data[0].to_company_region)
            formik.setFieldValue('from_api_key', migrationDetails.data[0].from_api_key)
            formik.setFieldValue('to_api_key', migrationDetails.data[0].to_api_key)
            let option = []
            option.push({ "dc_name": migrationDetails.data[0].from_company_region })
            option.push({ "dc_name": migrationDetails.data[0].to_company_region })
            option.push({ "company_login_name": migrationDetails.data[0].from_company_login_name, "company_name": migrationDetails.data[0].from_company_name })
            option.push({ "company_login_name": migrationDetails.data[0].to_company_login_name, "company_name": migrationDetails.data[0].to_company_name })

            setdropDownOptions(option)
        }
    }, [migrationDetails?.data]);

    useEffect(() => {
        if (currentMigID) {
            urlParams.current.id = currentMigID;
            dispatch(GETMIGRATIONDETAILS_REQ(urlParams.current));
        }
    }, [currentMigID]);

    const handleCheckboxChange = (e) => {
        setEnableDataMigration(e.target.checked);
        formik.setFieldValue('isDataMigrationEnabled', e.target.checked)
      };

    useEffect(() => {
        if (oppositeENVRegionList?.data) {
            setRegionData([...oppositeENVRegionList?.data, { "dc_name": "", "option_disabled": true }, ...currentENVRegionList]);
            formik.setFieldValue('regionObjectList', regionData)
        }
    }, [oppositeENVRegionList]);

    useEffect(() => {
        if (formik?.values?.to_company_region) {
            getCompanyList(formik?.values?.to_company_region, "", "to")
        }
    }, [formik?.values?.to_company_region])

    useEffect(() => {
        if (formik?.values?.from_company_region) {
            getCompanyList(formik?.values?.from_company_region, "", "from")
        }
    }, [formik?.values?.from_company_region])

    useEffect(() => {
     if(formik?.values?.cloneAccount && formik?.values?.cloneAccount != "None"){
        let payload = cloneSourceAccounts.find((item) => item.industry == formik?.values?.cloneAccount)
        formik.setFieldValue('isFromSourceAccount', true)
        formik.setFieldValue('from_api_key', payload?.zuper_api_key)
        formik.setFieldValue('from_company_uid', payload?.company_uid)
        formik.setFieldValue('isDataMigrationEnabled',false)
        formik.setFieldValue('from_company_ref_date', payload?.from_company_ref_date )
        setEnableDataMigration(false);
        setisFromSourceAccount(true)
        let option = []
        option.push({ "dc_name": payload?.region })
        option.push({ "company_login_name": payload.company_login_name, "company_name": payload.company_name })
        setdropDownOptions(option)
        formik.setFieldValue('from_company_region', payload?.region);
         setTimeout(function () {
             formik.setFieldValue('from_company_name', payload?.company_name);
             formik.setFieldValue('from_company_login_name', payload?.company_login_name);
         });
     }
     else if(formik?.values?.cloneAccount == "None"){
        setisFromSourceAccount(false)
        formik.setFieldValue('isFromSourceAccount', false)
        formik.setFieldValue('from_api_key', "")
        formik.setFieldValue('from_company_uid', "")
        formik.setFieldValue('isDataMigrationEnabled',false)
        formik.setFieldValue('from_company_ref_date', "")
        setEnableDataMigration(false);
        formik.setFieldValue('from_company_name', '');
        formik.setFieldValue('from_company_login_name', '');
         setTimeout(function () {
             formik.setFieldValue('from_company_region', '');
         });
    }
    }, [formik?.values?.cloneAccount])

    useEffect(() => {
        if (customersList.data) {
            setCompanyList({ ...companyList, [`${customersList.region}_${customersList.isWhere}`]: customersList.data })
        }
    }, [customersList]);


    const getCompanyList = (region, keyword, isWhere) => {
        const localRegionNameList = _.pluck(currentENVRegionList, 'dc_name')
        urlParams.current['region-code'] = region
        urlParams.current.neededRegion = localRegionNameList.indexOf(region) > -1 ? currentEnv : ((currentEnv == 'staging' || currentEnv == 'development') ? 'live' : 'staging')
        urlParams.current["filter.keyword"] = keyword || "";
        dispatch(GETCOMPANIES_REQ({ ...urlParams.current, isWhere }));
    }
    const apiKeyValidation = () => {
        dispatch(APIKEYVALIDATION_REQ(formik.values))
    }

    return (
        <section ariaLabelledby="primary-heading" className="flex h-full min-w-0 flex-1 flex-col lg:order-last">
            <div className="h-full">
                <div className="relative h-full w-full bg-white rounded-lg shadow px-4">
                    <div className="p-2">
                        <div className="flow-root">
                            <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                                    <div className="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                                        <h3 className="text-lg font-semibold leading-6 text-gray-900">
                                            Configuration
                                        </h3>
                                        <div className="mt-3 sm:ml-4 sm:mt-0">
                                            <div className="flex space-x-2">
                                                {!isReadOnlyView && <button type="button" onClick={() => apiKeyValidation()} disabled={!formik['isValid']}
                                                    className="relative inline-flex items-center gap-x-1.5 rounded-md bg-gray-800 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50">
                                                    Proceed
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                        stroke-width="1.5" stroke="currentColor" className="w-4 h-4">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                                                    </svg>
                                                </button>}
                                            </div>
                                        </div>
                                    </div>
                                   {!isReadOnlyView &&
                                    <div className="sm:col-span-3">
                                          <SearchDropdown
                                                formik={formik}
                                                required = {false}
                                                readOnly={isReadOnlyView}
                                                className=" w-full [&_.disabled-option]:!bg-transparent [&_.disabled-option]:rounded-none [&_.disabled-option]:border-b-[1px] [&_.disabled-option]:border-[#b9b7b7ba] [&_.disabled-option]:mb-3"
                                                name="cloneAccount"
                                                label="Clone from Standard Account"
                                                showNull={false}
                                                options={cloneAccountIndustry ? cloneAccountIndustry : []}
                                            />
                                        </div>
                                        }
                                    <div className="mt-4 mb-4 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                                   
                                        <div className="sm:col-span-3">
                                            <SearchDropdown
                                                formik={formik}
                                                readOnly={isReadOnlyView }
                                                disabled={isFromSourceAccount}
                                                className=" w-full [&_.disabled-option]:!bg-transparent [&_.disabled-option]:rounded-none [&_.disabled-option]:border-b-[1px] [&_.disabled-option]:border-[#b9b7b7ba] [&_.disabled-option]:mb-3"
                                                name="from_company_region"
                                                label="Source Company Environment"
                                                showNull={false}
                                                options={regionData ? regionData : []}
                                                optionId="dc_name"
                                                optionName="dc_name"
                                            />
                                        </div>
                                        {/* <>{JSON.stringify(regionData)}</> */}
                                        <div className="sm:col-span-3">
                                            <SearchDropdown
                                                formik={formik}
                                                readOnly={isReadOnlyView}
                                                className=" w-full [&_.disabled-option]:!bg-transparent [&_.disabled-option]:rounded-none [&_.disabled-option]:border-b-[1px] [&_.disabled-option]:border-[#b9b7b7ba] [&_.disabled-option]:mb-3"
                                                name="to_company_region"
                                                label="Destination Company Environment"
                                                showNull={false}
                                                options={regionData ? regionData : []}
                                                optionId="dc_name"
                                                optionName="dc_name"
                                            />
                                        </div>
                                        <div className="sm:col-span-3">
                                            <SearchDropdown
                                                formik={formik}
                                                readOnly={isReadOnlyView}
                                                onSearch={(keyword) => {
                                                    if (keyword) {
                                                        getCompanyList(formik?.values?.from_company_region, keyword, "from")
                                                    }
                                                }}
                                                debounce
                                                remote
                                                className="w-full"
                                                disabled={!formik.values.from_company_region || isFromSourceAccount}
                                                name="from_company_login_name"
                                                label="Source Company Name"
                                                showNull={false}
                                                onSelect={(e) => {
                                                    formik['values']['from_company_uid'] = e.company_uid
                                                    formik['values']['from_company_name'] = e.company_name
                                                }

                                                }
                                                options={ (isReadOnlyView || isFromSourceAccount) ? dropDownOptions : companyList[`${formik?.values?.from_company_region}_from`] ? companyList[`${formik?.values?.from_company_region}_from`] : []}
                                                optionId="company_login_name"
                                                optionName="company_name"
                                                formatDisplayName={(company) =>{
                                                    return `${company.company_name} (${company.company_login_name})`}
                                                }
                                            />
                                        </div>
                                        <div className="sm:col-span-3">
                                            <SearchDropdown
                                                formik={formik}
                                                readOnly={isReadOnlyView}
                                                onSearch={(keyword) => {
                                                    if (keyword) {
                                                        getCompanyList(formik?.values?.to_company_region, keyword, "to")
                                                    }
                                                }}
                                                debounce
                                                remote
                                                className="w-full"
                                                disabled={!formik.values.to_company_region}
                                                name="to_company_login_name"
                                                label="Destination Company Name"
                                                showNull={false}
                                                onSelect={(e) => {
                                                    formik['values']['to_company_uid'] = e.company_uid
                                                    formik['values']['to_company_name'] = e.company_name
                                                }

                                                }
                                                options={isReadOnlyView ? dropDownOptions : companyList[`${formik?.values?.to_company_region}_to`] ?? []}
                                                optionId="company_login_name"
                                                optionName="company_name"
                                                formatDisplayName={(company) =>
                                                    `${company.company_name} (${company.company_login_name})`
                                                }
                                            />
                                        </div>
                                        <div className="sm:col-span-3">
                                            <TextBox
                                                formik={formik}
                                                disabled={isFromSourceAccount}
                                                readOnly={isReadOnlyView}
                                                type="password"
                                                name="from_api_key"
                                                label="Source Company API Key"
                                                placeholder="Source Company API Key"
                                            />
                                        </div>

                                        <div className="sm:col-span-3">
                                            <TextBox
                                                formik={formik}
                                                readOnly={isReadOnlyView}
                                                type="password"
                                                name="to_api_key"
                                                label="Destination Company API Key"
                                                placeholder="Destination Company API Key"
                                            />
                                        </div>
                                    </div>
                                 {formik?.values?.cloneAccount != "None" ? ( <>
                                  <div className="flex items-center">
                                       <input id="enableDataMigration" name="enableDataMigration" type="checkbox"  checked={enableDataMigration} onChange={handleCheckboxChange} disabled={isReadOnlyView}className="border-gray-300 h-4 w-4 rounded text-gray-800 focus:ring-gray-800"/>
                                       <label htmlFor="enableDataMigration" className="ml-2 text-sm text-gray-700"> Migrate Data from Standard Account </label> 
                                        </div>
                                        </>) : null}
                                </div>
                               
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}